export default __webpack_public_path__ + "static/media/Tabl_3.aa58f51e.svg";